import React from "react";
import MuiButton, { ButtonProps as MuiButtonProps } from "@material-ui/core/Button";
import { useStyles } from './Button.styles';

interface IProps extends MuiButtonProps {
  variantType?: "primary" | "secondary" | "light";
  sizeType?: "small" | "regular" | "large";
  value: string;
  fullWidth?: boolean;
  clickHandler?: () => void;
}

const Button: React.FC<IProps> = ({
  disabled = false,
  variantType = "primary",
  sizeType = "regular",
  type = "button",
  value,
  fullWidth = false,
  clickHandler,
  className = "",
  ...rest
}) => {
  const classes = useStyles();

  const variantClass = classes[`variant_${variantType}`] || "";
  const sizeClass = classes[`size_${sizeType}`] || "";
  const fullWidthClass = fullWidth ? classes.fullWidth : "";

  return (
    <MuiButton
      className={`${classes.btn} ${variantClass} ${sizeClass} ${fullWidthClass} ${className}`}
      onClick={clickHandler}
      type={type}
      disabled={disabled}
      {...rest}
    >
      {value}
    </MuiButton>
  );
};

export default Button;